/**
 * Provide required product options data for vortex
 */
// ToDo DT-417: Use a more maintainable solution like enums
var Finish = {
  NONE: "",
  // None
  FOIL: "foil",
  // Metallic
  GLOSS: "gloss" // Spot UV

};
var Substrate = {
  MATTE: "matte",
  PREMIUM_MATTE: "premiumMatte",
  RECYCLED_MATTE: "recycledMatte",
  GLOSSY: "glossy",
  PEARL: "pearl",
  LINEN: "linen",
  KRAFT: "kraft",
  NATURAL: "natural",
  UNCOATED: "uncoated"
};
var Orientation = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
};
var ProductType = {
  FLAT_SHEET: "flatSheet",
  BI_FOLDED_SHEET: "biFoldSheet"
};
var Side = {
  FRONT: "front",
  BACK: "back",
  ALL: "all"
};
/**
 * Provide required product data for vortex based on a SKU
 */

var SKUToProductData = {
  // BC
  "PRD-X0KWG5Y8": {
    finish: {
      options: ["Finish"],
      values: {
        None: Finish.NONE,
        Metallic: Finish.FOIL,
        "Spot UV": Finish.GLOSS
      },
      default: Finish.GLOSS
    },
    substrate: {
      options: ["Stock"],
      values: {
        Matte: Substrate.MATTE,
        Glossy: Substrate.GLOSSY,
        Pearl: Substrate.PEARL,
        Linen: Substrate.LINEN,
        Kraft: Substrate.KRAFT,
        "Soft touch": Substrate.MATTE,
        "Recycled matte": Substrate.RECYCLED_MATTE,
        "Natural uncoated": Substrate.NATURAL,
        "Textured uncoated": Substrate.NATURAL
      },
      default: Substrate.MATTE
    },
    dimensions: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          width: 88,
          height: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          width: 58,
          height: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          width: 89,
          height: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          width: 44,
          height: 89
        }
      },
      default: {
        width: 88,
        height: 58
      }
    },
    trim: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 88,
          bottomRightY: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 58,
          bottomRightY: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 89,
          bottomRightY: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 44,
          bottomRightY: 89
        }
      },
      default: {
        topLeftX: 0,
        topLeftY: 0,
        bottomRightX: 88,
        bottomRightY: 58
      }
    },
    depth: {
      options: ["Weight", "Stock"],
      values: {
        PremiumMatte: 0.41,
        StandardMatte: 0.35,
        PremiumGlossy: 0.41,
        PremiumPearl: 0.402,
        StandardPearl: 0.366,
        PremiumLinen: 0.34,
        PremiumKraft: 0.51,
        StandardKraft: 0.455,
        "PremiumSoft touch": 0.41,
        "PremiumRecycled matte": 0.3,
        "StandardNatural uncoated": 0.43,
        "StandardTextured uncoated": 0.3
      },
      default: 0.3
    },
    orientation: {
      options: ["Product Orientation"],
      values: {
        Vertical: Orientation.VERTICAL,
        Horizontal: Orientation.HORIZONTAL
      },
      default: Orientation.HORIZONTAL
    },
    productType: {
      options: [],
      values: {},
      default: ProductType.FLAT_SHEET
    },
    productPadding: {
      options: [],
      values: {},
      default: 1.3
    },
    cornerRadius: {
      options: ["Cut Shape Type"],
      values: {
        Rectangle: 0,
        "Rounded Rectangle": 6
      },
      default: 0
    },
    colorFill: {
      options: [],
      values: {},
      default: undefined
    }
  },
  // BC
  "PRD-8CIJMQXT": {
    finish: {
      options: ["Finish"],
      values: {
        None: Finish.NONE,
        Metallic: Finish.FOIL,
        "Spot UV": Finish.GLOSS
      },
      default: Finish.GLOSS
    },
    substrate: {
      options: ["Stock"],
      values: {
        Matte: Substrate.MATTE,
        Glossy: Substrate.GLOSSY,
        Pearl: Substrate.PEARL,
        Linen: Substrate.LINEN,
        Kraft: Substrate.KRAFT,
        "Soft touch": Substrate.MATTE,
        "Recycled matte": Substrate.RECYCLED_MATTE,
        "Natural uncoated": Substrate.NATURAL,
        "Textured uncoated": Substrate.NATURAL
      },
      default: Substrate.MATTE
    },
    dimensions: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          width: 88,
          height: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          width: 58,
          height: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          width: 89,
          height: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          width: 44,
          height: 89
        }
      },
      default: {
        width: 88,
        height: 58
      }
    },
    trim: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 88,
          bottomRightY: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 58,
          bottomRightY: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 89,
          bottomRightY: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 44,
          bottomRightY: 89
        }
      },
      default: {
        topLeftX: 0,
        topLeftY: 0,
        bottomRightX: 88,
        bottomRightY: 58
      }
    },
    depth: {
      options: ["Weight", "Stock"],
      values: {
        PremiumMatte: 0.41,
        StandardMatte: 0.35,
        PremiumGlossy: 0.41,
        PremiumPearl: 0.402,
        StandardPearl: 0.366,
        PremiumLinen: 0.34,
        PremiumKraft: 0.51,
        StandardKraft: 0.455,
        "PremiumSoft touch": 0.41,
        "PremiumRecycled matte": 0.3,
        "StandardNatural uncoated": 0.43,
        "StandardTextured uncoated": 0.3
      },
      default: 0.3
    },
    orientation: {
      options: ["Product Orientation"],
      values: {
        Vertical: Orientation.VERTICAL,
        Horizontal: Orientation.HORIZONTAL
      },
      default: Orientation.HORIZONTAL
    },
    productType: {
      options: [],
      values: {},
      default: ProductType.FLAT_SHEET
    },
    productPadding: {
      options: [],
      values: {},
      default: 1.3
    },
    cornerRadius: {
      options: ["Cut Shape Type"],
      values: {
        Rectangle: 0,
        "Rounded Rectangle": 6
      },
      default: 0
    },
    colorFill: {
      options: [],
      values: {},
      default: undefined
    }
  },
  // BC
  "PRD-CIBYIJWX": {
    finish: {
      options: ["Finish"],
      values: {
        None: Finish.NONE,
        Metallic: Finish.FOIL,
        "Spot UV": Finish.GLOSS
      },
      default: Finish.NONE
    },
    substrate: {
      options: ["Stock"],
      values: {
        Matte: Substrate.MATTE,
        Glossy: Substrate.GLOSSY,
        Pearl: Substrate.PEARL,
        Linen: Substrate.LINEN,
        Kraft: Substrate.KRAFT,
        "Soft touch": Substrate.MATTE,
        "Recycled matte": Substrate.RECYCLED_MATTE,
        "Natural uncoated": Substrate.NATURAL,
        "Textured uncoated": Substrate.NATURAL
      },
      default: Substrate.MATTE
    },
    dimensions: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          width: 88,
          height: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          width: 58,
          height: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          width: 89,
          height: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          width: 44,
          height: 89
        }
      },
      default: {
        width: 88,
        height: 58
      }
    },
    trim: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 88,
          bottomRightY: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 58,
          bottomRightY: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 89,
          bottomRightY: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 44,
          bottomRightY: 89
        }
      },
      default: {
        topLeftX: 0,
        topLeftY: 0,
        bottomRightX: 88,
        bottomRightY: 58
      }
    },
    depth: {
      options: ["Weight", "Stock"],
      values: {
        PremiumMatte: 0.41,
        StandardMatte: 0.35,
        PremiumGlossy: 0.41,
        PremiumPearl: 0.402,
        StandardPearl: 0.366,
        PremiumLinen: 0.34,
        PremiumKraft: 0.51,
        StandardKraft: 0.455,
        "PremiumSoft touch": 0.41,
        "PremiumRecycled matte": 0.3,
        "StandardNatural uncoated": 0.43,
        "StandardTextured uncoated": 0.3
      },
      default: 0.3
    },
    orientation: {
      options: ["Product Orientation"],
      values: {
        Vertical: Orientation.VERTICAL,
        Horizontal: Orientation.HORIZONTAL
      },
      default: Orientation.HORIZONTAL
    },
    productType: {
      options: [],
      values: {},
      default: ProductType.FLAT_SHEET
    },
    productPadding: {
      options: [],
      values: {},
      default: 2.2
    },
    cornerRadius: {
      options: ["Cut Shape Type"],
      values: {
        Rectangle: 0,
        "Rounded Rectangle": 6
      },
      default: 0
    },
    colorFill: {
      options: [],
      values: {},
      default: undefined
    }
  },
  "PRD-RWLCHPA0": {
    finish: {
      options: ["Finish"],
      values: {
        None: Finish.NONE,
        Metallic: Finish.FOIL,
        "Spot UV": Finish.GLOSS
      },
      default: Finish.NONE
    },
    substrate: {
      options: ["Stock"],
      values: {
        Matte: Substrate.MATTE,
        Glossy: Substrate.GLOSSY,
        Pearl: Substrate.PEARL,
        Linen: Substrate.LINEN,
        Kraft: Substrate.KRAFT,
        "Soft touch": Substrate.MATTE,
        "Recycled matte": Substrate.RECYCLED_MATTE,
        "Natural uncoated": Substrate.NATURAL,
        "Textured uncoated": Substrate.NATURAL
      },
      default: Substrate.MATTE
    },
    dimensions: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          width: 88,
          height: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          width: 58,
          height: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          width: 89,
          height: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          width: 44,
          height: 89
        }
      },
      default: {
        width: 88,
        height: 58
      }
    },
    trim: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 88,
          bottomRightY: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 58,
          bottomRightY: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 89,
          bottomRightY: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 44,
          bottomRightY: 89
        }
      },
      default: {
        topLeftX: 0,
        topLeftY: 0,
        bottomRightX: 88,
        bottomRightY: 58
      }
    },
    depth: {
      options: ["Weight", "Stock"],
      values: {
        PremiumMatte: 0.41,
        StandardMatte: 0.35,
        PremiumGlossy: 0.41,
        PremiumPearl: 0.402,
        StandardPearl: 0.366,
        PremiumLinen: 0.34,
        PremiumKraft: 0.51,
        StandardKraft: 0.455,
        "PremiumSoft touch": 0.41,
        "PremiumRecycled matte": 0.3,
        "StandardNatural uncoated": 0.43,
        "StandardTextured uncoated": 0.3
      },
      default: 0.3
    },
    orientation: {
      options: ["Product Orientation"],
      values: {
        Vertical: Orientation.VERTICAL,
        Horizontal: Orientation.HORIZONTAL
      },
      default: Orientation.HORIZONTAL
    },
    productType: {
      options: [],
      values: {},
      default: ProductType.FLAT_SHEET
    },
    productPadding: {
      options: [],
      values: {},
      default: 2.2
    },
    cornerRadius: {
      options: ["Cut Shape Type"],
      values: {
        Rectangle: 0,
        "Rounded Rectangle": 6
      },
      default: 0
    },
    colorFill: {
      options: [],
      values: {},
      default: undefined
    }
  },
  "PRD-WBY4DECX": {
    finish: {
      options: ["Finish"],
      values: {
        None: Finish.NONE,
        Metallic: Finish.FOIL,
        "Spot UV": Finish.GLOSS
      },
      default: Finish.NONE
    },
    substrate: {
      options: ["Stock"],
      values: {
        Matte: Substrate.MATTE,
        Glossy: Substrate.GLOSSY,
        Pearl: Substrate.PEARL,
        Linen: Substrate.LINEN,
        Kraft: Substrate.KRAFT,
        "Soft touch": Substrate.MATTE,
        "Recycled matte": Substrate.RECYCLED_MATTE,
        "Natural uncoated": Substrate.NATURAL,
        "Textured uncoated": Substrate.NATURAL
      },
      default: Substrate.MATTE
    },
    dimensions: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          width: 88,
          height: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          width: 58,
          height: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          width: 89,
          height: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          width: 44,
          height: 89
        }
      },
      default: {
        width: 88,
        height: 58
      }
    },
    trim: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 88,
          bottomRightY: 58
        },
        "VerticalStandard (85 x 55 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 58,
          bottomRightY: 88
        },
        "HorizontalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "VerticalSquare (65 x 65 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 69,
          bottomRightY: 69
        },
        "HorizontalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 89,
          bottomRightY: 44
        },
        "VerticalSlim (40 x 85 mm)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 44,
          bottomRightY: 89
        }
      },
      default: {
        topLeftX: 0,
        topLeftY: 0,
        bottomRightX: 88,
        bottomRightY: 58
      }
    },
    depth: {
      options: ["Weight", "Stock"],
      values: {
        PremiumMatte: 0.41,
        StandardMatte: 0.35,
        PremiumGlossy: 0.41,
        PremiumPearl: 0.402,
        StandardPearl: 0.366,
        PremiumLinen: 0.34,
        PremiumKraft: 0.51,
        StandardKraft: 0.455,
        "PremiumSoft touch": 0.41,
        "PremiumRecycled matte": 0.3,
        "StandardNatural uncoated": 0.43,
        "StandardTextured uncoated": 0.3
      },
      default: 0.3
    },
    orientation: {
      options: ["Product Orientation"],
      values: {
        Vertical: Orientation.VERTICAL,
        Horizontal: Orientation.HORIZONTAL
      },
      default: Orientation.HORIZONTAL
    },
    productType: {
      options: [],
      values: {},
      default: ProductType.FLAT_SHEET
    },
    productPadding: {
      options: [],
      values: {},
      default: 2.2
    },
    cornerRadius: {
      options: ["Cut Shape Type"],
      values: {
        Rectangle: 0,
        "Rounded Rectangle": 6
      },
      default: 0
    },
    colorFill: {
      options: [],
      values: {},
      default: undefined
    }
  },
  "PRD-JKENF4EI": {
    finish: {
      options: ["SpecialFinishing"],
      values: {
        None: Finish.NONE,
        Metallic: Finish.FOIL,
        "Single Sided Spot UV Varnish": Finish.GLOSS
      },
      default: Finish.NONE
    },
    substrate: {
      options: ["Paper Stock"],
      values: {
        Matte: Substrate.MATTE,
        Glossy: Substrate.GLOSSY,
        Pearl: Substrate.PEARL,
        Linen: Substrate.LINEN,
        Kraft: Substrate.KRAFT,
        "Soft touch": Substrate.MATTE,
        "Recycled matte": Substrate.RECYCLED_MATTE,
        "Natural uncoated": Substrate.NATURAL,
        "Textured uncoated": Substrate.NATURAL
      },
      default: Substrate.MATTE
    },
    dimensions: {
      options: ["Product Orientation", "Format"],
      values: {
        "Landscape(91x55)": {
          width: 94,
          height: 58
        },
        "Portrait(91x55)": {
          width: 58,
          height: 94
        }
      },
      default: {
        width: 94,
        height: 58
      }
    },
    trim: {
      options: ["Product Orientation", "Format"],
      values: {
        "Landscape(91x55)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 94,
          bottomRightY: 58
        },
        "Portrait(91x55)": {
          topLeftX: 0,
          topLeftY: 0,
          bottomRightX: 58,
          bottomRightY: 94
        }
      },
      default: {
        topLeftX: 0,
        topLeftY: 0,
        bottomRightX: 94,
        bottomRightY: 58
      }
    },
    depth: {
      options: ["Paper Thickness", "Paper Stock"],
      values: {
        PremiumMatte: 0.41,
        StandardMatte: 0.35,
        PremiumGlossy: 0.41,
        PremiumPearl: 0.402,
        StandardPearl: 0.366,
        PremiumLinen: 0.34,
        PremiumKraft: 0.51,
        StandardKraft: 0.455,
        "PremiumSoft touch": 0.41,
        "PremiumRecycled matte": 0.3,
        "StandardNatural uncoated": 0.43,
        "StandardTextured uncoated": 0.3
      },
      default: 0.3
    },
    orientation: {
      options: ["Product Orientation"],
      values: {
        Portrait: Orientation.VERTICAL,
        Horizontal: Orientation.HORIZONTAL
      },
      default: Orientation.HORIZONTAL
    },
    productType: {
      options: [],
      values: {},
      default: ProductType.FLAT_SHEET
    },
    productPadding: {
      options: [],
      values: {},
      default: 2.2
    },
    cornerRadius: {
      options: ["CutShape"],
      values: {
        Rectangle: 0,
        "Rounded Rectangle": 6
      },
      default: 0
    },
    colorFill: {
      options: [],
      values: {},
      default: undefined
    }
  },
  //  square BC
  "PRD-0XWCRIW8": {
    finish: {
      options: ["Finish"],
      values: {
        None: Finish.NONE,
        Metallic: Finish.FOIL,
        "Spot UV": Finish.GLOSS
      },
      default: Finish.GLOSS
    },
    substrate: {
      options: ["Stock"],
      values: {
        Matte: Substrate.MATTE,
        Glossy: Substrate.GLOSSY,
        Pearl: Substrate.PEARL,
        Linen: Substrate.LINEN,
        Kraft: Substrate.KRAFT,
        "Soft touch": Substrate.MATTE,
        "Recycled matte": Substrate.RECYCLED_MATTE,
        "Natural uncoated": Substrate.NATURAL,
        "Textured uncoated": Substrate.NATURAL
      },
      default: Substrate.MATTE
    },
    dimensions: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalSquare (65 x 65 mm)": {
          width: 69,
          height: 69
        }
      },
      default: {
        width: 69,
        height: 69
      }
    },
    trim: {
      options: ["Product Orientation", "Size"],
      values: {
        "HorizontalSquare (65 x 65 mm)": {
          topLeftX: 2,
          topLeftY: 2,
          bottomRightX: 67,
          bottomRightY: 67
        }
      },
      default: {
        topLeftX: 0,
        topLeftY: 0,
        bottomRightX: 88,
        bottomRightY: 58
      }
    },
    depth: {
      options: ["Weight", "Stock"],
      values: {
        PremiumMatte: 0.41,
        StandardMatte: 0.35,
        PremiumGlossy: 0.41,
        PremiumPearl: 0.402,
        StandardPearl: 0.366,
        PremiumLinen: 0.34,
        PremiumKraft: 0.51,
        StandardKraft: 0.455,
        "PremiumSoft touch": 0.41,
        "PremiumRecycled matte": 0.3,
        "StandardNatural uncoated": 0.43,
        "StandardTextured uncoated": 0.3
      },
      default: 0.3
    },
    orientation: {
      options: ["Product Orientation"],
      values: {
        Horizontal: Orientation.HORIZONTAL
      },
      default: Orientation.HORIZONTAL
    },
    productType: {
      options: [],
      values: {},
      default: ProductType.FLAT_SHEET
    },
    productPadding: {
      options: [],
      values: {},
      default: 1.3
    },
    cornerRadius: {
      options: ["Cut Shape Type"],
      values: {
        Rectangle: 0
      },
      default: 0
    },
    colorFill: {
      options: [],
      values: {},
      default: undefined
    }
  }
};

function getProductOptionValue(SKU, productOptionKey, selectedOptions) {
  // Data for the current SKU
  var productData = SKUToProductData[SKU]; // Data for the given productOption

  var productOptionData = productData[productOptionKey]; // Get the selected product option's key from the given array of selected options

  var selectedOptionKey = productOptionData.options.map(function (option) {
    return selectedOptions[option];
  }).join(""); // Get the product option value
  // If not available, return the default product option

  var productOptionValue = productOptionData.values[selectedOptionKey] ? productOptionData.values[selectedOptionKey] : productOptionData.default;
  return productOptionValue;
}

var getSupportedSides = function getSupportedSides(productOption) {
  switch (productOption) {
    case Substrate.GLOSSY:
    case Finish.FOIL:
    case Finish.GLOSS:
      return Side.FRONT;

    default:
      return Side.ALL;
  }
};

function getSubstrateBySide(vortex, substrate, side) {
  if (side === Side.BACK && getSupportedSides(substrate) === Side.FRONT) {
    // If the substrate is not supported on the back, then default to a matte backside
    return vortex.substrates.matte;
  }

  return vortex.substrates[substrate];
}

function getFinishBySide(vortex, finish, side) {
  if (finish !== Finish.NONE && !(side === Side.BACK && getSupportedSides(finish) === Side.FRONT)) {
    return vortex.finishes[finish];
  }

  return undefined;
}

function getPageByProductTypeAndSide(productType, side) {
  // Front side
  if (side === Side.FRONT) {
    return productType === ProductType.FLAT_SHEET ? 1 : [1, 2];
  } // Back side


  return productType === ProductType.FLAT_SHEET ? 2 : 3;
} // Get the surface configuration for the given sku and selected options


function getSurfaceConfiguration(vortex, SKU, options) {
  var productType = getProductOptionValue(SKU, "productType", options);
  var substrate = getProductOptionValue(SKU, "substrate", options);
  var finish = getProductOptionValue(SKU, "finish", options);
  var surfaceConfiguration = {
    front: {
      substrate: getSubstrateBySide(vortex, substrate, Side.FRONT),
      finish: getFinishBySide(vortex, finish, Side.FRONT),
      page: getPageByProductTypeAndSide(productType, Side.FRONT)
    },
    back: {
      substrate: getSubstrateBySide(vortex, substrate, Side.BACK),
      finish: getFinishBySide(vortex, finish, Side.BACK),
      page: getPageByProductTypeAndSide(productType, Side.BACK)
    }
  };
  return surfaceConfiguration;
}
/**
 * Provide required product configuration data for vortex
 */


var isSKUSupported = function isSKUSupported(SKU) {
  return !!SKUToProductData[SKU];
};

function getVortexProductConfigurationFromSKU(vortex, SKU, options) {
  // This is same as isVortexSupported that is provided to the client of vortex
  // to check if the product is vortex suported
  if (!isSKUSupported) {
    throw Error("SKU ".concat(SKU, " not supported by Vortex"));
  } // The vortex object on the window needs to exist before we can use the product configuration function


  if (!vortex) {
    throw Error("vortex not defined");
  }

  var dimensions = getProductOptionValue(SKU, "dimensions", options);
  var productOptions = {
    surfaces: getSurfaceConfiguration(vortex, SKU, options),
    type: vortex.productTypes[getProductOptionValue(SKU, "productType", options)],
    orientation: vortex.productOrientations[getProductOptionValue(SKU, "orientation", options)],
    fullBleed: dimensions,
    aspectRatio: dimensions.width / dimensions.height,
    depth: getProductOptionValue(SKU, "depth", options),
    trim: getProductOptionValue(SKU, "trim", options),
    cornerRadius: getProductOptionValue(SKU, "cornerRadius", options),
    colorFill: getProductOptionValue(SKU, "colorFill", options)
  };
  return productOptions;
}

function getProductPadding(SKU, options) {
  return getProductOptionValue(SKU, "productPadding", options);
}

function ensureProjectionsIgnored(previewInstructionsUrl) {
  if (previewInstructionsUrl.indexOf("ignoreProjection") > -1) {
    return previewInstructionsUrl;
  }

  if (previewInstructionsUrl.indexOf("?") === -1) {
    return "".concat(previewInstructionsUrl, "?ignoreProjection=true");
  }

  return "".concat(previewInstructionsUrl, "&ignoreProjection=true");
}

export { Side as S, getVortexProductConfigurationFromSKU as a, ensureProjectionsIgnored as e, getProductPadding as g, isSKUSupported as i };